// initial state
const state = {
  all: [],
}

// getters
const getters = {
  all: state => state.all,
}

// actions
const actions = {
  all({ dispatch }) {
    return dispatch(
      'http',
      {
        method: 'GET',
        url: '/transaction/all',
      },
      { root: true },
    )
  },
  getTransactionsByStudentId({ dispatch }, id) {
    return dispatch(
      'http',
      {
        method: 'GET',
        url: `/transaction/studentId/${id}`,
      },
      { root: true },
    )
  },
  getAvailableTransactionByStudentId({ dispatch }, id) {
    return dispatch(
      'http',
      {
        method: 'GET',
        url: `/transaction/student/${id}/available`,
      },
      { root: true },
    )
  },
  getRecentTransactions({ dispatch }) {
    return dispatch(
      'http',
      {
        method: 'GET',
        url: '/transaction/recent',
      },
      { root: true },
    )
  },
  async create({ dispatch }, transaction) {
    const { data } = await dispatch(
      'http',
      {
        method: 'GET',
        url: '/transaction/create',
        params: { transaction },
      },
      { root: true },
    )
    return data
  },
  async createBySchedule({ dispatch }, { csID }) {
    const { data } = await dispatch(
      'http',
      {
        method: 'POST',
        url: `/transaction/create/byschedule/${csID}`,
      },
      { root: true },
    )
    return data
  },
}

// mutations
const mutations = {
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
